<template>
  <div class="pt-9">
    <v-row no-gutters align="center" justify="center">
      <v-col class="text-left" cols="12" sm="12" md="8">
        <v-form ref="form" lazy-validation>
          <span
            :class="
              $vuetify.breakpoint.smAndDown
                ? 'title-style-mobile'
                : 'title-style-tablet'
            "
            >Fazer login</span
          >
          <br />
          <p
            :class="
              $vuetify.breakpoint.smAndDown
                ? 'subtitle-style-mobile'
                : 'subtitle-style-tablet'
            "
          >
            Use seu e-mail corporativo ou a matrícula para acessar o AlertaDIS.
          </p>
          <div class="pt-4 form-input-group">
            <v-text-field
              class="text-field"
              id="email"
              color="accent lighten-1"
              background-color="transparent"
              v-model="email"
              :rules="[loginFieldRules]"
              prepend-inner-icon="icon-alertadis-user-circle"
              :append-icon="loginFieldRules == true ? 'icon-alertadis-check' : ''"
              outlined
              required
              placeholder="Informe seu e-mail ou matrícula"
            />
            <label for="email">E-mail ou matrícula</label>
          </div>
          <div class="form-input-group">
            <v-text-field
              class="text-field"
              id="password"
              color="accent lighten-1"
              background-color="transparent"
              v-model="password"
              :rules="[passwordRules]"
              outlined
              required
              prepend-inner-icon="icon-alertadis-padlock"
              :append-icon="passwordRules === true ? 'icon-alertadis-check' : ''"
              :type="showPassword ? 'text' : 'password'"
              placeholder="Informe a senha"
            />
            <label for="password">Senha</label>
          </div>
          <v-checkbox
            class="mt-1 check-form"
            color="accent lighten-1"
            v-model="showPassword"
            label="Mostrar senha"
          />

          <v-row no-gutters align="center">
            <v-col class="d-flex align-center">
              <v-btn
                class="btn-form"
                color="accent lighten-1"
                height="50"
                width="82"
                large
                @click="signIn"
                :loading="loading"
              >
                <span>Entrar</span>
              </v-btn>
              <a @click="forgot" class="label-change-password pl-4"
                >Esqueci a senha</a
              >
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import routes from "@/router/routes";
import { LOCAL_STORAGE_ACCESS_TOKEN } from "@/helpers/local_storage_constants";
import { snackbar } from "@/core/controller/snackbar_controller";

export default {
  name: "LoginForm",
  data: () => ({
    email: "",
    password: undefined,
    showPassword: false,
    checkbox: false,
    loading: false,
    alert: false,
    messageError: "",
    passwordRulesValue: false,
    loginFieldRules: null,
  }),
  mounted() {
    window.addEventListener("keydown", this.handleEnter);
    localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
  },
  destroyed() {
    window.removeEventListener("keydown", this.handleEnter);
  },
  created() {
    this.password = "";
    this.loginFieldRules = this.emailRules;
  },
  watch: {
    password(value) {
      this.passwordRules = this.validatePassword(value);
    },
    email() {
      if (!this.email.includes("@")) {
        this.loginFieldRules = this.registryRules;
      } else {
        this.loginFieldRules = this.emailRules;
      }
    },
    loginFieldRules() {
      if (/^[a-zA-Z]{1}[0-9]{6}$/.test(this.email)) {
        this.email = this.email.toUpperCase();
      }
    },
  },
  computed: {
    emailRules() {
      if (!this.email) {
        return "Você precisa informar o e-mail ou a matrícula para acessar o AlertaDIS.";
      }
      if (/.+@.+\..+/.test(this.email) == false) {
        return "Este e-mail é inválido. Informe o seu e-mail no formato exemplo@exemplo.com.";
      }
      if (
        /^\w+([-+.']\w+)*@?(simepar.br|copel.com|jointecnologia.com.br)$/.test(
          this.email
        ) == false
      ) {
        return "O e-mail deve pertencer ao Simepar ou a Copel.";
      }
      return true;
    },
    registryRules() {
      if (/^[a-zA-Z]{1}[0-9]{6}$/.test(this.email) == false) {
        return "E-mail ou matrícula inválido.";
      }
      return true;
    },
    passwordRules: {
      set(value) {
        if (value) {
          this.passwordRulesValue = value;
          return;
        }

        this.passwordRulesValue = true;
      },
      get() {
        return this.passwordRulesValue;
      },
    },
  },
  methods: {
    handleEnter(e) {
      if (e.key === "Enter") {
        this.signIn();
      }
    },
    validatePassword(value) {
      !value
        ? "Você precisa informar a senha para acessar o AlertaDIS."
        : undefined;

      if (!value) {
        return "Você precisa informar a senha para acessar o AlertaDIS.";
      }

      if (value.length < 8) {
        return "A senha deve ter pelo menos 8 caracteres.";
      }

      if (value == "") return true;
    },
    forgot() {
      this.$router.push(routes.login.children.forgotPassword.path);
    },
    async signIn() {
      if (this.$refs.form.validate()) {
        try {
          this.loading = true;
          await this.$store.dispatch("signIn", {
            email: this.email,
            password: this.password,
          });
          // this.$gtag.event('signIn', { method: 'Google' })
        } catch (error) {
          //TODO: Handle errors
          snackbar.show({
            type: "error",
            title: error.name,
            message: error.message,
            timeout: 5000,
          });
          //this.passwordRules = error.message;
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
label {
  order: -1;
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-base);
}

.text-field {
  border-radius: 8px;
}

.btn-form {
  text-transform: none;
  border-radius: 8px;
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}

.check-form {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}

.v-input:focus-within + label {
  color: var(--v-accent-lighten1) !important;
}

.form-input-group {
  display: flex;
  flex-direction: column;
}

.form-input-group /deep/ .v-input__icon--append .v-icon {
  color: var(--v-success-base) !important;
}

.title-style-mobile {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0.25px;
  color: var(--v-primary-base);
}

.title-style-tablet {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 34px;
  line-height: 45px;
  letter-spacing: 0.25px;
  color: var(--v-primary-base);
}

.subtitle-style-mobile {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-darken2);
}

.subtitle-style-tablet {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-darken2);
}

.label-change-password {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-accent-lighten1) !important;
}
</style>
